/**
 * Mirrors com.medprompt.document.request.DocumentUpdateRequest.
 * A partial update: the server treats null as "no change", so only the fields the caller set are
 * written. Nested update bodies are passed through as given.
 *
 * @param {object} fields
 * @returns {object}
 */
export function toDocumentUpdateRequest(fields) {
  const body = {};
  if (fields.nhsId !== undefined) body.nhsId = fields.nhsId;
  if (fields.briefSummary !== undefined) body.briefSummary = fields.briefSummary;
  if (fields.existingPatientCodes !== undefined) body.existingPatientCodes = fields.existingPatientCodes;
  if (fields.newCodes !== undefined) body.newCodes = fields.newCodes;
  if (fields.measurements !== undefined) body.measurements = fields.measurements;
  if (fields.outcomeTasks !== undefined) body.outcomeTasks = fields.outcomeTasks;
  if (fields.assigneeId !== undefined) body.assigneeId = fields.assigneeId;
  if (fields.detailsUpdate !== undefined) body.detailsUpdate = fields.detailsUpdate;
  if (fields.overrideTitle !== undefined) body.overrideTitle = fields.overrideTitle;
  if (fields.existingCodeUpdate !== undefined) body.existingCodeUpdate = fields.existingCodeUpdate;
  if (fields.deletedExistingCodes !== undefined) body.deletedExistingCodes = fields.deletedExistingCodes;
  if (fields.newCodeUpdate !== undefined) body.newCodeUpdate = fields.newCodeUpdate;
  if (fields.frequentCodeUpdate !== undefined) body.frequentCodeUpdate = fields.frequentCodeUpdate;
  if (fields.deletedNewCodes !== undefined) body.deletedNewCodes = fields.deletedNewCodes;
  if (fields.measurementUpdate !== undefined) body.measurementUpdate = fields.measurementUpdate;
  if (fields.taskUpdate !== undefined) body.taskUpdate = fields.taskUpdate;
  if (fields.riskCategory !== undefined) body.riskCategory = fields.riskCategory;
  return body;
}
